import React, { useMemo, useState } from 'react';
import { useStaticQuery, graphql } from "gatsby";

import NavItem from "./nav-item";
import Button from '../button/button';

import Linkedin from '../../assets/images/icons/linkedin.svg';
import Facebook from '../../assets/images/icons/facebook.svg';
import Twitter from '../../assets/images/icons/x.svg';
import Instagram from '../../assets/images/icons/instagram.svg';
import Tiktok from '../../assets/images/icons/tiktok.svg';

const Nav = ({ isOpen, setOpen, location }) => {
  const [ openChild, setOpenChild ] = useState(null);

  const socialMedia = [
    { url: "https://www.linkedin.com/company/flaunt-digital/",
      alt: "LinkedIn",
      image: Linkedin,
    },
    { url: "https://en-gb.facebook.com/FlauntDigital/",
      alt: "Facebook",
      image: Facebook,
    },
    { url: "https://twitter.com/flauntdigital",
      alt: "Twitter",
      image: Twitter,
    },
    { url: "https://www.instagram.com/flauntdigital/",
      alt: "Instagram",
      image: Instagram,
    },
    { url: "https://www.tiktok.com/@flauntdigital",
      alt: "Tiktok",
      image: Tiktok,
    },
  ];
  
  const mainMenuQuery = useStaticQuery(graphql`
    query {
      allWpMenuItem(filter: {locations: {eq: HEADER}}, sort: {order: ASC}) {
        nodes {
          label
          url
          parentId
          childItems {
            nodes {
              url
              label
            }
          }
        }
      }
    }
  `)

  const currentPath = useMemo(() => {
    if(typeof location === "undefined") {
      return "";
    }else {
      return location?.pathname;
    }
  }, [location])

  const mainMenu = useMemo(() => {
    const menuObject = [];

    mainMenuQuery?.allWpMenuItem?.nodes.forEach((menuItem) => {

      if(menuItem?.parentId) {
        return;
      }

      const menuItemObject = {
        label: menuItem?.label,
        url: menuItem?.url,
        children: menuItem.childItems.nodes
      };

      menuObject.push(menuItemObject);
    })

    return menuObject;
  }, [mainMenuQuery])

  return (
    <nav
      className={ `main-nav ${isOpen && "active"}` }
    >
      <ul
        className="nav-links"
      >
        { mainMenu && mainMenu.map((menuItem, index) => {
          return (
            <NavItem
              currentPath={ currentPath }
              key={` nav-item-${index} `}
              index={ index }
              menuItem={ menuItem }
              openChild={ openChild }
              setOpen={ setOpen }
              setOpenChild={ setOpenChild }
            />
          );
        })}
      </ul>
      <div
        className="nav-contact-us"
      >
        <div className="social-icons">
          { socialMedia.map((site) => {
            return(
              <a 
                href= { site.url }
                className="social-icon"
                target="_blank"
                rel="noreferrer"
                key={ site.alt }
                title={`Follow us on ${site.alt}`}
              >
                <img 
                  alt={`${site.alt} Logo`}
                  className="social-icon-image"
                  loading="lazy"
                  src={ site.image }
                />
              </a>
            )
          }) }
        </div>
      </div>
      <Button to={'/contact-us/'} type={'nav-contact'} children={"Get in touch"} />
    </nav>
  )
}

export default Nav;
